package com.nonopn.skywatcher.common.api

import io.ktor.http.HttpStatusCode
import kotlinx.serialization.json.Json

class BackendErrorException(
    message: String,
    val body: String,
    val code: HttpStatusCode
) : Exception(message) {
    // only contains the error as body

    inline fun <reified T> error(): T = JsonProvider.json.decodeFromString(body)
}

object JsonProvider {
    val json = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
    }
}
